import {Pipe, PipeTransform} from '@angular/core';
import {ContextService} from '../services/context.service';

/*
 *
 */
@Pipe({
  name: 'orgResolver'
})
export class OrgResolverPipe implements PipeTransform {


  constructor(private context: ContextService) {

  }

  transform(message: string): string {
    if (message) {
      if (this.context.organization()) {
        message = message.replace(this.context.organization().id, this.context.organization().name);
      }
      const regex = /urn:janus:organization:([a-f0-9]{32})/g;
      return message.replace(regex, (match, p1) => `${p1.substring(0, 8)}`);
    } else {
      return ''
    }
  }
}
